import { Theme } from '../../../UNSAFE_Theme';
import { baseVars, colorSchemeVars, scaleVars } from '../themeContract.css';

/* components will directly import themes for now, we will reintroduce the component themes into the global theme after 15.0 release
import { UserAssistanceStableTheme } from '../../../UNSAFE_UserAssistance/themes/stable/UserAssistanceTheme';
import { TextFieldStableTheme } from '../../../UNSAFE_TextField/themes/stable/TextFieldTheme';
import { FormLayoutStableTheme } from '../../../UNSAFE_TextField/themes/stable/FormLayoutTheme';
import { LabelStableTheme } from '../../../UNSAFE_Label/themes/stable/LabelTheme';
import { MessageBannerStableTheme } from '../../../UNSAFE_MessageBanner/themes/stable/MessageBannerTheme';
import { MessageToastStableTheme } from '../../../UNSAFE_MessageToast/themes/stable/MessageToastTheme';
import { ComponentMessageStableTheme } from '../../../UNSAFE_ComponentMessage/themes/stable/ComponentMessageTheme';
import { ReadonlyTextFieldInputStableTheme } from '../../../UNSAFE_TextField/themes/stable/ReadonlyTextFieldInputTheme';
import { ReadonlyTextFieldStableTheme } from '../../../UNSAFE_TextField/themes/stable/ReadonlyTextFieldTheme';
import { TextFieldInputStableTheme } from '../../../UNSAFE_TextField/themes/stable/TextFieldInputTheme';
import { DialogStableTheme } from '../../../UNSAFE_Dialog/themes/stable/DialogTheme';
import { DrawerPopupStableTheme } from '../../../UNSAFE_DrawerPopup/themes/stable/DrawerPopupTheme';
import { CollapsibleStableTheme } from '../../../UNSAFE_Collapsible/themes/stable/CollapsibleTheme';
import { WindowOverlayStableTheme } from '../../../UNSAFE_WindowOverlay/themes/stable/WindowOverlayTheme';
import { TooltipContentStableTheme } from '../../../hooks/UNSAFE_useTooltip/themes/stable/TooltipContentTheme';
import { SkeletonStableTheme } from '../../../UNSAFE_Skeleton/themes/stable/SkeletonTheme';
import { AvatarStableTheme } from '../../../UNSAFE_Avatar/themes/stable/AvatarTheme';
import { BaseButtonStableTheme } from '../../../UNSAFE_BaseButton/themes/stable/BaseButtonTheme';
import { ButtonLayoutStableTheme } from '../../../UNSAFE_ButtonLayout/themes/stable/ButtonLayoutTheme';
import { SplitMenuButtonStableTheme } from '../../../UNSAFE_SplitMenuButton/themes/stable/SplitMenuButtonTheme';
import { RadioStableTheme } from '../../../UNSAFE_RadioItem/themes/stable/RadioTheme';
import { RadioIconStableTheme } from '../../../UNSAFE_RadioItem/themes/stable/RadioIconTheme';
import { IndexerStableTheme } from '../../../UNSAFE_Indexer/themes/stable/IndexerTheme';
import { LinkStableTheme } from '../../../UNSAFE_Link/themes/stable/LinkTheme';
import { GroupedListStableTheme } from '../../../UNSAFE_GroupedList/themes/stable/GroupedListTheme';
import { TabBarItemStableTheme } from '../../../UNSAFE_TabBarItem/themes/stable/TabBarItemTheme';
import { PopupStableTheme } from '../../../UNSAFE_Popup/themes/stable/PopupTheme';
import { ProgressBarStableTheme } from '../../../UNSAFE_ProgressBar/themes/stable/ProgressBarTheme';
import { ProgressCircleStableTheme } from '../../../UNSAFE_ProgressCircle/themes/stable/ProgressCircleTheme';
import { FilePickerStableTheme } from '../../../UNSAFE_FilePicker/themes/stable/FilePickerTheme';
import { MenuSeparatorStableTheme } from '../../../UNSAFE_Menu/themes/stable/MenuSeparatorTheme';
import { MenuItemStableTheme } from '../../../UNSAFE_Menu/themes/stable/MenuItemTheme';
import { NavigationListItemStableTheme } from '../../../UNSAFE_NavigationList/themes/stable/NavigationListItemTheme';
import { RatingGaugeStableTheme } from '../../../UNSAFE_RatingGauge/themes/stable/RatingGaugeTheme';
*/

const Stable: Theme = {
  name: 'stable',
  /* components will directly import themes for now, we will reintroduce the component themes into the global theme after 15.0 release
  components: {
    Avatar: AvatarStableTheme,
    Badge: BadgeStableTheme,
    BaseButton: BaseButtonStableTheme,
    ButtonLayout: ButtonLayoutStableTheme,
    Label: LabelStableTheme,
    Link: LinkStableTheme,
    ComponentMessage: ComponentMessageStableTheme,
    MessageBanner: MessageBannerStableTheme,
    MessageToast: MessageToastStableTheme,
    FilePicker: FilePickerStableTheme,
    FormLayout: FormLayoutStableTheme,
    Popup: PopupStableTheme,
    ProgressBar: ProgressBarStableTheme,
    ProgressCircle: ProgressCircleStableTheme,
    TextField: TextFieldStableTheme,
    TextFieldInput: TextFieldInputStableTheme,
    UserAssistance: UserAssistanceStableTheme,
    RadioItem: RadioStableTheme,
    RadioIcon: RadioIconStableTheme,
    RatingGauge: RatingGaugeStableTheme,
    ReadonlyTextField: ReadonlyTextFieldStableTheme,
    ReadonlyTextFieldInput: ReadonlyTextFieldInputStableTheme,
    Collapsible: CollapsibleStableTheme,
    Dialog: DialogStableTheme,
    DrawerPopup: DrawerPopupStableTheme,
    Skeleton: SkeletonStableTheme,
    SplitMenuButton: SplitMenuButtonStableTheme,
    WindowOverlay: WindowOverlayStableTheme,
    TooltipContent: TooltipContentStableTheme,
    Train: TrainStableTheme,
    Indexer: IndexerStableTheme,
    GroupedList: GroupedListStableTheme,
    TabBarItem: TabBarItemStableTheme,
    MenuSeparator: MenuSeparatorStableTheme,
    MenuItem: MenuItemStableTheme,
    NavigationListItem: NavigationListItemStableTheme,
    Floating: FloatingStableTheme,
    MeterBar: MeterBarStableTheme,
    MeterCircle: MeterCircleStableTheme
  },*/
  base: baseVars,
  colorScheme: colorSchemeVars,
  scale: scaleVars
};

export { Stable };
